import {BaseEvent} from "./BaseEvent";

export class MeasureResultEvent extends BaseEvent {
  static RESULTS_UPDATED = 'resultsUpdated';
  static RESULT_SHAPES_UPDATED = 'resultShapesUpdated';
}